module.exports = __webpack_public_path__ + "static/feature-audits-4c1a6ba95e1c276c88add60359d47a63.png";